import { View, Text } from 'react-native';
import PreviewComponent from './PreviewComponent';
import { useSelector } from 'react-redux';
import { DefaultRootState } from '@reduxLocal/persistState';
import React from 'react';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';
import { useDeviceType } from '@hooks/useDeviceType';
import globalStyles from '@stylesheet';
import { MaterialIcons } from '@expo/vector-icons';

export type SchemaPreviewerType = {
  /**
   * Flag to determine if the user is interacting with the schema
   * @param interaction - boolean
   */
  interaction: boolean;
}

const SchemaPreviewer = ({interaction}: SchemaPreviewerType) => {
  const content = useSelector((state: DefaultRootState) => state.uploadPreview.present.dataHeld);
  const theme = themeSelector();
  const { isTablet } = useDeviceType();

  const schema = content;

  return (
    <View style={{
      flex: 1,
      minHeight: isTablet ? 300 : 250,
      backgroundColor: 'transparent',
      top: -70,
    }}>
      {schema && schema.length > 0 ? (
        <View style={{
          flex: 1,
          paddingLeft: isTablet ? 18 : 12,
          paddingVertical: isTablet ? 8 : 6,
          transform: [{ scale: 0.9 }],
          overflowY: 'scroll',
          paddingBottom: '83dvh'
        }}>
          {schema.map((item, index) => {
            return (
              <PreviewComponent
                key={index}
                dataField={item}
                indexLength={content.length}
                currentIndex={index}
                interaction={interaction}
              />
            )
          })}
        </View>
      ) : (
        <View style={[
          globalStyles.modernCard,
          theme ? globalStyles.modernBgLight : globalStyles.modernBgDark,
          {
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
            padding: isTablet ? 40 : 30,
            margin: isTablet ? 16 : 12
          }
          ]}>
            <MaterialIcons
              name="schema"
              size={isTablet ? 64 : 56}
              color={theme ? '#9ca3af' : '#6b7280'}
            />
            <Text style={{
              color: theme ? '#64748b' : '#94a3b8',
              fontSize: isTablet ? 16 : 14,
              fontWeight: '600',
              marginTop: 16,
              textAlign: 'center'
            }}>
              No schema fields available
            </Text>
            <Text style={{
              color: theme ? '#94a3b8' : '#64748b',
              fontSize: isTablet ? 13 : 12,
              marginTop: 8,
              textAlign: 'center',
              lineHeight: isTablet ? 18 : 16
            }}>
              Add fields to preview your data schema
            </Text>
          </View>
      )}
    </View>
  )
}
export default SchemaPreviewer